import React from "react";

import classNames from "classnames";

import SwitchUsingFormContext from "./SwitchUsingFormContext";
import SwitchUsingFormControl from "./SwitchUsingFormControl";

import type { ChangeEvent, JSX } from "react";

import type { InputProps } from "./types";

type SwitchProps = InputProps & {
  color?: string;
  onChangeCustom?: (value: ChangeEvent<HTMLInputElement>) => void;
};

export default function Switch({
  name,
  label,
  sublabel,
  infoText,
  isRequired = false,
  isReadOnly = false,
  isReversed,
  defaultValue,
  isCompact,
  className,
  isNoWrap,
  control,
  size = "md",
  color,
  onChangeCustom,
}: SwitchProps): JSX.Element {
  const labelClassNames = classNames(
    "relative mb-0 block rounded-full bg-input after:absolute after:rounded-full after:bg-white after:duration-300 after:content-[''] has-[:checked]:bg-primary has-[:checked]:after:-translate-x-full",
    size === "md" &&
      "after:left-[2px] after:top-[2px] after:size-[21px] h-[25px] w-[42px] active:after:w-[28px] has-[:checked]:after:left-[calc(100%-2px)]",
    size === "sm" &&
      "after:left-[2px] after:top-[2px] after:size-[17px] h-[21px] w-[37px] active:after:w-[22px] has-[:checked]:after:left-[calc(100%-2px)]",
    isReadOnly ? "cursor-not-allowed" : "cursor-pointer",
  );

  return control ? (
    <SwitchUsingFormControl
      className={className}
      color={color}
      control={control}
      defaultValue={defaultValue}
      infoText={infoText}
      isCompact={isCompact}
      isNoWrap={isNoWrap}
      isReadOnly={isReadOnly}
      isRequired={isRequired}
      isReversed={isReversed}
      label={label}
      labelClassNames={labelClassNames}
      name={name}
      onChangeCustom={onChangeCustom}
      sublabel={sublabel}
    />
  ) : (
    <SwitchUsingFormContext
      className={className}
      color={color}
      defaultValue={defaultValue}
      infoText={infoText}
      isCompact={isCompact}
      isNoWrap={isNoWrap}
      isReadOnly={isReadOnly}
      isRequired={isRequired}
      isReversed={isReversed}
      label={label}
      labelClassNames={labelClassNames}
      name={name}
      sublabel={sublabel}
    />
  );
}
